import { Typography } from '@material-ui/core'
import ChannelIcon from '@material-ui/icons/AccountTree'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import useStyles from './styles/ChannelAddHeader.styles'

export const ChannelAddHeader = () => {
  const classes = useStyles()
  const { id } = useParams<{ id: string }>()

  return (
    <div className={classes.header}>
      <ChannelIcon fontSize="large" />
      <Typography
        data-cy="addNewChannelTitle"
        className={classes.title}
        variant="h3"
        gutterBottom>
        {getTranslate(id ? 'Edit Channel' : 'Add New Channel')}
      </Typography>
    </div>
  )
}
